/**
 * Returns capitalized string (as in sentence)
 * @param v - string to capitalize
 */
export function capitalize(v?: string): string {
  if (v === undefined || v.length < 1) {
    return '';
  }

  return v.charAt(0).toUpperCase() + v.slice(1);
}

/**
 * Returns shortened string if provided value length is greater than (keepFirst + keepLast)
 * @param v - string to shorten
 * @param keepFirst - keep N first symbols
 * @param keepLast - keep M last symbols
 * @param replacer - ellipsis replacer
 */
export function shorten(v: string, keepFirst = 6, keepLast = 4, replacer = '····'): string {
  if (v.length < keepFirst + keepLast) {
    return v;
  }

  return `${v.slice(0, keepFirst)}${replacer}${v.slice(-keepLast)}`;
}
